// DO NOT EDIT BY HAND — populated by: npm run extract-letterform

import { letterC } from "./c"
import { letterCHEVRON } from "./chevron"
import { letterM } from "./m"

export const letterforms = { c: letterC, chevron: letterCHEVRON, m: letterM }
export type LetterKey = keyof typeof letterforms
